import { ScreenWidth, breakpoints } from './constants';
// only for tests
export function _respondToAbove(windowWidth: number, minWidth: ScreenWidth) {
    return breakpoints[minWidth] <= windowWidth;
}

export function _respondToBelow(windowWidth: number, maxWidth: ScreenWidth) {
    return breakpoints[maxWidth] >= windowWidth;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/app/styles/scripts/_uiHelpers.ts